var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pad-separator"},[_c('vb-icon',{staticClass:"mr-2",attrs:{"name":'lamp_light',"color":'#003B95'}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('strong',[_vm._v("E se ti spostassi un po'?")]),_vm._v(" Ecco delle ottime alternative nei dintorni di Roma. ")])
}]

export { render, staticRenderFns }